import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/material/styles';
import React__default from 'react';
import '../../../icons/abstract/AbstractArcIcon.js';
import '../../../icons/AddCircleIcon.js';
import '../../../icons/AddCircleOutlineIcon.js';
import '../../../icons/ArrowCircleRightIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import { ArrowRightIcon } from '../../../icons/ArrowRightIcon.js';
import '../../../icons/BoltIcon.js';
import '../../../icons/BookmarkStarIcon.js';
import '../../../icons/CalendarIcon.js';
import '../../../icons/CancelIcon.js';
import '../../../icons/CheckCircleIcon.js';
import '../../../icons/CheckMarkIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronLeftIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CloseIcon.js';
import '../../../icons/CopyIcon.js';
import '../../../icons/MenuIcon.js';
import '../../../icons/NotificationActiveIcon.js';
import '../../../icons/PaperPlaneIcon.js';
import '../../../icons/PendingIcon.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PlayCircleIcon.js';
import '../../../icons/RemoveCircleIcon.js';
import '../../../icons/SearchIcon.js';
import '../../../icons/SellIcon.js';
import '../../../icons/ShareIcon.js';
import '../../../icons/ShoppingBagIcon.js';
import '../../../icons/SmartphoneIcon.js';
import '../../../icons/StarIcon.js';
import '../../../icons/StarOutlineIcon.js';
import { SuccessCheckCircleIcon } from '../../../icons/SuccessCheckCircleIcon.js';
import '../../../icons/ThumbsDownIcon.js';
import '../../../icons/ThumbsUpIcon.js';
import '../../../icons/TuneIcon.js';
import '../../../icons/FourPointStarIcon.js';
import { Button } from '../../../Components/Button/Button.js';
import '../../../Components/Button/CustomDtcBagButton.js';
import '../../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../../types/filters.js';
import '../../../utils/assetUtils.js';
import '../../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { escapeUriPath, formatMoney } from '../../../utils/stringUtils.js';
import '../../../utils/broadcast.js';
import { MOBILE_SCREEN_SIZE } from '../../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '@splitsoftware/splitio-react';
import '@tanstack/react-query';
import '../../../Auth/index.js';
import '../../../types/Campaign.js';
import '../../../types/product.js';
import '../../../api/graphQl/brand.js';
import '../../../api/graphQl/product.js';
import '../../../api/cache/appConfigQueryOptions.js';
import '@brandclub/types';
import 'lodash/omitBy';
import 'lodash/isNil';
import '../../../utils/logger.js';
import { ButtonLoadingEllipsis } from '../Loading/index.js';

const BrandCardContainer = styled('div')(() => ({
    border: 'solid 1px #dcdddc',
    width: '100%',
    height: '100%',
    borderRadius: 12,
    // matches product card padding
    padding: '16px 16px 16px 22px',
    paddingTop: 58,
    cursor: 'pointer',
    boxSizing: 'border-box',
    transition: 'background-color 0.4s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0,
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
        padding: 10,
        paddingTop: 52,
        width: '100%',
    },
}));
const BrandLogoContainer = styled('div')(() => ({
    width: 'calc(100% - 24px)',
    maxWidth: '190px',
    aspectRatio: '1/1',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));
const BrandLogoImg = styled('img')(({ theme }) => ({
    width: '100%',
    maxWidth: 149,
    aspectRatio: '1/1',
    backgroundColor: theme.vars.palette.common.white,
    objectFit: 'contain',
    borderRadius: 999,
}));
const BrandName = styled('h2')(({ theme }) => ({
    fontSize: 22,
    fontWeight: 600,
    marginBottom: 16.7,
    marginTop: 20,
    color: theme.vars.palette.text.primary,
    overflow: 'hidden',
    width: '80%',
    textAlign: 'center',
    textDecoration: 'none',
    letterSpacing: 0.36,
    WebkitLineClamp: 1,
    lineHeight: 1.5,
    height: `1.5em`,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-word',
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
        fontSize: 16,
    },
}));
const BrandCardStatusMessage = styled('div')(({ theme }) => ({
    fontSize: 16,
    fontWeight: 600,
    marginTop: 29.3,
    color: theme.vars.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
        fontSize: 12,
    },
    '.arrow': {
        width: 13,
        height: 13,
        objectFit: 'contain',
        marginLeft: 10,
        [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
            width: 10,
            height: 10,
        },
    },
}));
const BrandCardButton = styled(Button)(() => ({
    height: 40,
    fontSize: 17,
    fontWeight: 600,
    minWidth: 108,
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
        height: 30,
        fontSize: 12,
        minWidth: 88,
    },
}));
const getBrandActivityPath = (brand) => `/${escapeUriPath(brand.name)}/b/${brand.brandId}/branddashboard/rewards/activity`;
const getBrandHomePath = (brand) => `/${escapeUriPath(brand.name)}/b/${brand.brandId}/home`;
const BrandCardJoinButton = (props) => {
    var _a, _b;
    if (props.joined) {
        return (React__default.createElement(BrandCardButton, { variant: "outline", color: "primary" }, formatMoney((_b = (_a = props.brand) === null || _a === void 0 ? void 0 : _a.rewardAmount) !== null && _b !== void 0 ? _b : 0)));
    }
    if (props.joinedState === 'not_join') {
        return (React__default.createElement(Button, { variant: "solid", color: "tertiary", onClick: props.onJoin }, "Join"));
    }
    if (props.joinedState === 'joining') {
        return (React__default.createElement(Button, { variant: "solid", color: "tertiary" },
            "Joining",
            React__default.createElement(ButtonLoadingEllipsis, { baseFontSize: 17, blue: true })));
    }
    return (React__default.createElement(BrandCardButton, null,
        React__default.createElement(SuccessCheckCircleIcon, { className: "button_img" }),
        "Member"));
};
const BrandCardJoinMessage = (props) => {
    const { brand, LinkComponent } = props;
    const viewActivityPath = getBrandActivityPath(brand);
    const homePath = getBrandHomePath(brand);
    if (props.joinedState === 'joined' && props.reward) {
        return (React__default.createElement(BrandCardStatusMessage, null, `You earned ${formatMoney(props.reward)} by joining this club`));
    }
    return (React__default.createElement(LinkComponent, { to: props.joined ? viewActivityPath : homePath, style: {
            textDecoration: 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
        } },
        React__default.createElement(BrandCardStatusMessage, null,
            React__default.createElement("span", null, props.joined ? 'View activity' : `Visit ${brand.name}`),
            React__default.createElement(ArrowRightIcon, { className: "arrow", color: "primary" }))));
};
const ProductBrandCard = (_a) => {
    var { brand, joined, joinedState, reward, LinkComponent } = _a, props = __rest(_a, ["brand", "joined", "joinedState", "reward", "LinkComponent"]);
    return (React__default.createElement(BrandCardContainer, null,
        React__default.createElement(LinkComponent, { to: getBrandHomePath(brand), style: {
                textDecoration: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
            } },
            React__default.createElement(BrandLogoContainer, null,
                React__default.createElement(BrandLogoImg, { alt: "logo", src: brand.imageUrl })),
            React__default.createElement(BrandName, null, brand.name),
            React__default.createElement(BrandCardJoinButton, { brand: brand, joined: joined, onJoin: props.onJoin, joinedState: joinedState })),
        React__default.createElement(BrandCardJoinMessage, { joinedState: joinedState, reward: reward, joined: joined, brand: brand, LinkComponent: LinkComponent })));
};

export { ProductBrandCard as default };
//# sourceMappingURL=ProductBrandCard.js.map
